import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { NotFoundPage } from "@/components/ui/NotFoundPage";
import SEOHead from "@/components/seo/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <SEOHead
        title="Page Not Found - Control Exchange"
        description="The page you're looking for doesn't exist or has been moved."
        noindex
      />
      <NotFoundPage
        title="Oops! Page not found"
        description="The page you're looking for doesn't exist or has been moved."
      />
    </>
  );
};

export default NotFound;
